@let isMobile = isMobile$ | async;
<!-- keeps focus while it loads: aria-disabled instead of native disabled (which drops focus), and the guard blocks
clicks. Just the icon on mobile, named with the tooltip text exactly, or screen readers read it twice -->
<button
  type="button"
  class="button-reset button header-button"
  [attr.aria-disabled]="isLoading || null"
  [attr.aria-label]="isMobile ? text : null"
  [matTooltip]="isMobile ? text : ''"
  [matTooltipShowDelay]="500"
  (click)="!isLoading && pressed.emit()">
  <span
    class="icon"
    [class.show-progress]="isLoading">
    <mat-icon>{{ icon }}</mat-icon>
    @if (isLoading) {
      <mat-spinner
        [diameter]="20"
        color="accent">
      </mat-spinner>
    }
  </span>
  @if (!isMobile) {
    {{ text }}
  }
</button>
